import PicklistMetadata from "../PicklistMetadata";

// Non-static picklist over the EnterpriseTermCurrent EC, used to pick a relationship's PARENT term.
// Display = the term's Name; value = EnterpriseTermUSID (the LOGICAL term, not a revision) so the
// relationship survives every revise on that end. The EC lists exactly one row per term — the revision
// it currently resolves to — which is why a never-published DRAFT is still pickable here. Results are
// scoped by realm/visibility via the EC's request headers, so no explicit search specification.
class EnterpriseTermParentPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "EnterpriseTermParent";
        this.static = false;
        this.enterpriseComponent = "EnterpriseTermCurrent";
        this.useRealm = false;
        this.searchSpecification = null;
        this.sortSpecification = {"Name": "ASC"};
        this.typeField = "Name";
        this.typeValue = "EnterpriseTermUSID";
        this.allowNoSelection = false;
    }
}

export default EnterpriseTermParentPicklistMetadata;
